import type { ReactNode } from 'react';

import { Card } from './Card';

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <Card className="text-center py-10">
      {icon && (
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-sage-lt text-sage-dk">
          {icon}
        </div>
      )}
      <h3 className="font-display font-bold text-base text-brown mb-1">{title}</h3>
      {description && <p className="text-sm text-brown-md mb-4">{description}</p>}
      {action}
    </Card>
  );
}
